import React from 'react';
import { useField } from 'formik';
import { Button } from '@mui/material';

const UploadClaimHistory = (props) => {
    const { errorText, ...rest } = props;
    const [field, meta] = useField(props);

    return (
        <label htmlFor="upload-file">
            <input
                accept=".doc,.docx,.pdf,.png,.jpg,.jpeg"
                id="upload-file"
                type="file"
                {...field}
                {...rest}
                style={{ display: 'none' }}
            />

            <Button variant="contained" component="span" style={{ marginTop: '10px' }}>
                Upload
            </Button>
        </label>
    );
};

export default UploadClaimHistory;